import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import List from "../components/List";
import { updateLoading } from "../store/reducers/loading";
import ViewDetail from "./ViewDetail";

const BountyList = () => {
	const [data, setData] = useState([]);
	const [toggleList, setToggleList] = useState(false);
	const [index, setIndex] = useState(0);
	const dispatch = useDispatch();

	const getList = async () => {
		dispatch(updateLoading(true));
		await axios.get("http://localhost:4000/api/projects").then(({ data }) => setData(data));
		console.table("data", data);
		dispatch(updateLoading(false));
	};

	const getSelector = (idx: number) => {
		setToggleList(true);
		setIndex(idx);
	};

	useEffect(() => {
		// (async () => await getList())();
		getList();
	}, []);

	return (
		<>
			{toggleList ? (
				<ViewDetail data={data[index]}></ViewDetail>
			) : (
				<List title={"BountyList"} data={data} getSelector={getSelector} />
			)}
		</>
	);
};

export default BountyList;
